/* eslint eqeqeq: off */
import React from "react";
import './index.css';
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Input from "../../../Components/Control/Input";
import {connect} from "react-redux";
import moment from "jalali-moment";
import Date from "../../../Components/Control/Date";
import Resource from "../../../Resource";
import PropTypes from 'prop-types';
import Notif from "../../../Components/Notif";
import {updateBase} from "../../../Redux/Actions/base";
import Patient from '../../../Server/Patient';
import {Tool} from '../../../App';
import Select from '../../../Components/Control/Select';
import {HospitalOrgEmerRequest, OrganizationOrgEmerRequest, SectionOrgEmerRequest} from '../../../Server/OrgEmerRequest';
import MyComponent from '../../../Components/MyComponent';
import InputButton from '../../../Components/Control/InputButton';

class ModalOrgEmerRequest extends MyComponent {
    constructor(props) {
        super(props);
        props.refer.current = this;


        this.state = {
            sections: [
                {id: '', text: '...'},
                ...props.base.hospitalSections.map(item => {
                    return {id: item.sectionId, text: item.sectionName};
                })
            ],
            error: false,
            loading: false,
            fields: {}
        };

        this.ref = {
            modal: React.createRef(),
            patientFileCode: React.createRef(),
            docterId: React.createRef(),
            patientBiography: React.createRef(),
            sectionId: React.createRef(),
            insert: React.createRef(),
            sectionUpdate: React.createRef(),
            bloodBankUpdate: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        patientFileCode: x => Boolean(x) || 'شماره پرونده وارد نشده است.',
        docterId: x => Boolean(x?.[0]?.id) || 'نام پزشک وارد نشده است.',
        patientBiography: x => Boolean(x) || 'شرح حال بیمار وارد نشده است.',
        sectionId: x => Boolean(x[0]?.id) || 'بخش انتخاب نشده است.'
    };

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state, props} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.loading !== nextState.loading ||
            state.fields !== nextState.fields ||
            props.base !== nextProps.base;
    }

    render() {
        const {state, props} = this;
        const section = state.action === 'SECTION_INSERT' || state.action === 'SECTION_UPDATE';
        const bloodBank = state.action === 'BLOOD_BANK_INSERT' || state.action === 'BLOOD_BANK_UPDATE';
        const readOnly = state.action === ModalAction.VIEW;
        const doctors = [
            {id:'',text:'...'},
            ...props.base.doctors
        ];

        return <React.Fragment>
            <Modal ref={this.ref.modal}
                   name={'ModalOrgEmerRequest'}
                   size={'large'}
                   title={'فرم درخواست اورژانسی از سازمان'}
                   required={true}
                   error={this.state.error}
                   loading={this.state.loading}
                   onClose={this.props.onClose}>
                <ModalContent>
                    <div className={'table-border'} style={{marginBottom: 10}}>
                        <table style={{textAlign: 'center'}}>
                            <tbody>
                            <tr style={{backgroundColor: '#c8dfe9'}}>
                                <td colSpan={3}>
                                    <div className={'dis-f'}>
                                        <div className={'flex ali-c'} style={{fontSize: 15, fontWeight: 500}}>
                                            فرم درخواست خون و فرآورده‌های آن توسط بانک خون بیمارستان‌ها از<br/>
                                            واحد بخش خون پایگاه‌های انتقال خون در موارد اورژانس
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr style={{backgroundColor: '#c8dfe9'}}>
                                <td/>
                                <td style={{fontSize: 11, fontWeight: 500}}>مسئول تکمیل فرم:</td>
                                <td/>
                            </tr>
                            <tr style={{backgroundColor: '#c8dfe9'}}>
                                <td style={{fontSize: 13, fontWeight: 500}}>1- مسئول بانک خون و پزشک معالج</td>
                                <td style={{fontSize: 13, fontWeight: 500}}>2- نماینده بیمارستان جهت تحویل گرفتن فرآورده</td>
                                <td style={{fontSize: 13, fontWeight: 500}}>3- فرد تحویل گیرنده فرآورده در بانک خون</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="table-border" style={{marginBottom: 10}}>
                        <table>
                            <tbody>
                            <tr>
                                <td className={'bl verticalCell'} rowSpan={17} style={{backgroundColor: '#95c4d7', color: 'white', fontSize: 20, fontWeight: 500}}><p style={{transform: 'rotate(-90deg) translate(-110%,0)'}}>تکمیل توسط پزشک</p></td>
                                <td className={'bl bb'}><Input className={'pad-4'} label={'استان'} readOnly={true} value={state?.fields?.patientProvinceStr}/></td>
                                <td className={'bl bb'}><Input className={'pad-4'} label={'شهرستان'} readOnly={true} value={state?.fields?.patientCityStr}/></td>
                                <td className={'bb'}><Input className={'pad-4'} label={'نام بیمارستان'} readOnly={true} value={props.user?.hospitalFullName||state.data?.hospitalShortName}/></td>
                            </tr>
                            <tr>
                                <td className={'bl bb'} colSpan={2}><Input className={'pad-4'} label={'نام و نام خانوادگی بیمار'} readOnly={true} value={state?.fields?.patientFullName}/></td>
                                <td className={'bb'}><InputButton ref={this.ref.patientFileCode} className={'pad-4'} label={'شماره پرونده بیمار'} readOnly={readOnly || !section} value={state?.fields?.patientFileCode} validation={this.validations.patientFileCode} buttonTitle={'جستجو'} onButtonClick={this.patientFileCodeSubmitHandler.bind(this)} onEnter={this.patientFileCodeSubmitHandler.bind(this)} onChange={this.setField.bind(this, 'patientFileCode')}/></td>
                                {/*<td className={'bb'}><Input ref={this.ref.patientFileCode} className={'pad-4'} label={'شماره پرونده بیمار'} readOnly={readOnly || !section} value={state?.fields?.patientFileCode} validation={this.validations.patientFileCode} onBlur={this.patientFileCodeSubmitHandler.bind(this)} onEnter={this.patientFileCodeSubmitHandler.bind(this)} onChange={this.setField.bind(this, 'patientFileCode')}/></td>*/}
                            </tr>
                            <tr>
                                <td className={'bl bb'} colSpan={2}><Select ref={this.ref.docterId} className={'pad-4'} label={'نام، نام خانوادگی پزشک درخواست کننده'} validation={this.validations.docterId} readOnly={readOnly || !section} options={doctors} value={state?.fields?.docterId} onChange={this.setField.bind(this, 'docterId')}/></td>
                                <td className={'bb'}><Date className={'pad-4'} label={'تاریخ و ساعت درخواست'} readOnly={true} value={state.fields?.sectionRequestDateTime} format={'jYYYY-jMM-jDD HH:mm:ss'}/></td>
                            </tr>
                            <tr>
                                <td colSpan={2}><Input ref={this.ref.patientBiography} className={'pad-4'} label={'شرح حال مختصر بیمار'} validation={this.validations.patientBiography} readOnly={readOnly || !section} value={state?.fields?.patientBiography} onChange={this.setField.bind(this, 'patientBiography')}/></td>
                                <td><Select ref={this.ref.sectionId} className={'pad-4'} label={'بخش'} readOnly={readOnly || !section} options={state.sections} validation={this.validations.sectionId} value={state?.fields?.sectionId} onChange={this.setField.bind(this, 'sectionId')}/></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="table-border">
                        <table>
                            <tbody>
                            <tr className={'bb lab'} style={{backgroundColor: '#e2edf2'}}>
                                <td className={'bl verticalCell'} rowSpan={17} style={{backgroundColor: '#1d90d0', color: 'white', fontSize: 20, fontWeight: 500}}><p>تکمیل توسط مسئول بانک خون</p></td>
                                <td className={'bl'} style={{width: '170px'}}>خون و فرآورده‌های آن</td>
                                <td className={'bl'} style={{width: '5%'}}>+O</td>
                                <td className={'bl'} style={{width: '5%'}}>-O</td>
                                <td className={'bl'} style={{width: '5%'}}>+A</td>
                                <td className={'bl'} style={{width: '5%'}}>-A</td>
                                <td className={'bl'} style={{width: '5%'}}>+B</td>
                                <td className={'bl'} style={{width: '5%'}}>-B</td>
                                <td className={'bl'} style={{width: '5%'}}>+AB</td>
                                <td className={'bl'} style={{width: '5%'}}>-AB</td>
                                <td className={'bl'} style={{width: '5%'}}>جمع</td>
                                <td>علت اورژانسی بودن فرآورده</td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} style={{backgroundColor: '#e2edf2'}}>خون کامل (WB)</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.wbJson?.o_POSCount} onChange={this.setField.bind(this, 'wbJson.o_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.wbJson?.o_NEGCount} onChange={this.setField.bind(this, 'wbJson.o_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.wbJson?.a_POSCount} onChange={this.setField.bind(this, 'wbJson.a_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.wbJson?.a_NEGCount} onChange={this.setField.bind(this, 'wbJson.a_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.wbJson?.b_POSCount} onChange={this.setField.bind(this, 'wbJson.b_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.wbJson?.b_NEGCount} onChange={this.setField.bind(this, 'wbJson.b_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.wbJson?.aB_POSCount} onChange={this.setField.bind(this, 'wbJson.aB_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.wbJson?.aB_NEGCount} onChange={this.setField.bind(this, 'wbJson.aB_NEGCount')}/></td>
                                <td className={'bl lab'}>{state?.fields?.wbJson?.sum}</td>
                                <td><Input className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.wbJson?.description} onChange={this.setField.bind(this, 'wbJson.description')}/></td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} style={{backgroundColor: '#e2edf2'}}>گلبول قرمز متراکم (RBC)</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.rbcJson?.o_POSCount} onChange={this.setField.bind(this, 'rbcJson.o_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.rbcJson?.o_NEGCount} onChange={this.setField.bind(this, 'rbcJson.o_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.rbcJson?.a_POSCount} onChange={this.setField.bind(this, 'rbcJson.a_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.rbcJson?.a_NEGCount} onChange={this.setField.bind(this, 'rbcJson.a_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.rbcJson?.b_POSCount} onChange={this.setField.bind(this, 'rbcJson.b_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.rbcJson?.b_NEGCount} onChange={this.setField.bind(this, 'rbcJson.b_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.rbcJson?.aB_POSCount} onChange={this.setField.bind(this, 'rbcJson.aB_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.rbcJson?.aB_NEGCount} onChange={this.setField.bind(this, 'rbcJson.aB_NEGCount')}/></td>
                                <td className={'bl lab'}>{state?.fields?.rbcJson?.sum}</td>
                                <td><Input className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.rbcJson?.description} onChange={this.setField.bind(this, 'rbcJson.description')}/></td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} style={{backgroundColor: '#e2edf2'}}>پلاکت (PLT)</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.pltJson?.o_POSCount} onChange={this.setField.bind(this, 'pltJson.o_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.pltJson?.o_NEGCount} onChange={this.setField.bind(this, 'pltJson.o_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.pltJson?.a_POSCount} onChange={this.setField.bind(this, 'pltJson.a_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.pltJson?.a_NEGCount} onChange={this.setField.bind(this, 'pltJson.a_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.pltJson?.b_POSCount} onChange={this.setField.bind(this, 'pltJson.b_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.pltJson?.b_NEGCount} onChange={this.setField.bind(this, 'pltJson.b_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.pltJson?.aB_POSCount} onChange={this.setField.bind(this, 'pltJson.aB_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.pltJson?.aB_NEGCount} onChange={this.setField.bind(this, 'pltJson.aB_NEGCount')}/></td>
                                <td className={'bl lab'}>{state?.fields?.pltJson?.sum}</td>
                                <td><Input className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.pltJson?.description} onChange={this.setField.bind(this, 'pltJson.description')}/></td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} style={{backgroundColor: '#e2edf2'}}>پلاسمای تازه منجمد (FFP)</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.ffpJson?.o_POSCount} onChange={this.setField.bind(this, 'ffpJson.o_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.ffpJson?.o_NEGCount} onChange={this.setField.bind(this, 'ffpJson.o_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.ffpJson?.a_POSCount} onChange={this.setField.bind(this, 'ffpJson.a_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.ffpJson?.a_NEGCount} onChange={this.setField.bind(this, 'ffpJson.a_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.ffpJson?.b_POSCount} onChange={this.setField.bind(this, 'ffpJson.b_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.ffpJson?.b_NEGCount} onChange={this.setField.bind(this, 'ffpJson.b_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.ffpJson?.aB_POSCount} onChange={this.setField.bind(this, 'ffpJson.aB_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.ffpJson?.aB_NEGCount} onChange={this.setField.bind(this, 'ffpJson.aB_NEGCount')}/></td>
                                <td className={'bl lab'}>{state?.fields?.ffpJson?.sum}</td>
                                <td><Input className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.ffpJson?.description} onChange={this.setField.bind(this, 'ffpJson.description')}/></td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} style={{backgroundColor: '#e2edf2'}}>کرایو (CRYO)</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.cryJson?.o_POSCount} onChange={this.setField.bind(this, 'cryJson.o_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.cryJson?.o_NEGCount} onChange={this.setField.bind(this, 'cryJson.o_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.cryJson?.a_POSCount} onChange={this.setField.bind(this, 'cryJson.a_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.cryJson?.a_NEGCount} onChange={this.setField.bind(this, 'cryJson.a_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.cryJson?.b_POSCount} onChange={this.setField.bind(this, 'cryJson.b_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.cryJson?.b_NEGCount} onChange={this.setField.bind(this, 'cryJson.b_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.cryJson?.aB_POSCount} onChange={this.setField.bind(this, 'cryJson.aB_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.cryJson?.aB_NEGCount} onChange={this.setField.bind(this, 'cryJson.aB_NEGCount')}/></td>
                                <td className={'bl lab'}>{state?.fields?.cryJson?.sum}</td>
                                <td><Input className={'pad-4'} align={"center"} readOnly={readOnly || !bloodBank} value={state?.fields?.cryJson?.description} onChange={this.setField.bind(this, 'cryJson.description')}/></td>
                            </tr>
                            <tr>
                                <td className={'bl'} colSpan={6}><Input className={'pad-4'} label={'نام و نام خانوادگی مسئول بانک خون'} readOnly={true} value={state?.fields?.bloodBankName}/></td>
                                <td className={'bl'} colSpan={5}><Date className={'pad-4'} label={'تاریخ و ساعت درخواست'} readOnly={true} value={state?.fields?.bloodBankRequestDateTime} format={'jYYYY-jMM-jDD HH:mm:ss'}/></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </ModalContent>
                <ModalControls>
                    {state.action === 'SECTION_INSERT' && <React.Fragment>
                        <Button refer={this.ref.insert} className={'mar-4'} theme={'blue'} onClick={this.insertClickHandler.bind(this)}>ثبت درخواست</Button>
                    </React.Fragment>}
                    {state.action === 'SECTION_UPDATE' && <Button refer={this.ref.sectionUpdate} className={'mar-4'} theme={'blue'} onClick={this.updateSectionClickHandler.bind(this)}>ویرایش درخواست</Button>}
                    {state.action === 'BLOOD_BANK_UPDATE' && <Button refer={this.ref.bloodBankUpdate} className={'mar-4'} theme={'blue'} onClick={this.updateBloodBankClickHandler.bind(this)}>ویرایش درخواست</Button>}
                    <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
        </React.Fragment>;
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    fieldWillUpdate(keys, value, currentFields, nextFields) {
        switch (keys[0]) {
            case 'patientFileCode':
                delete nextFields?.patientProvinceStr;
                delete nextFields?.patientCityStr;
                delete nextFields?.patientFullName;
                this.setState({patientFileInfo: undefined});
                break;
            case 'wbJson':
            case 'rbcJson':
            case 'pltJson':
            case 'ffpJson':
            case 'cryJson':
                nextFields[keys[0]].sum = parseInt(nextFields[keys[0]]?.o_POSCount || 0) + parseInt(nextFields[keys[0]]?.o_NEGCount || 0) + parseInt(nextFields[keys[0]]?.a_POSCount || 0) + parseInt(nextFields[keys[0]]?.a_NEGCount || 0) + parseInt(nextFields[keys[0]]?.b_POSCount || 0) + parseInt(nextFields[keys[0]]?.b_NEGCount || 0) + parseInt(nextFields[keys[0]]?.aB_POSCount || 0) + parseInt(nextFields[keys[0]]?.aB_NEGCount || 0) || '';
                break;
            default:
        }
    }

    insertClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            if (!state.patientFileInfo) {
                new Notif({message: 'شماره پرونده بیمار معتبر نمی باشد.', theme: 'error'}).show();
                return;
            }

            ref.insert.current.loading();
            this.setState({error: null});

            SectionOrgEmerRequest.insert({
                patientFileCodeId: state.patientFileInfo?.patientFileCodeId,
                patientFileCode: state.patientFileInfo?.patientFileCode,
                patientFirstName: state.patientFileInfo?.patientFirstName,
                patientLastName: state.patientFileInfo?.patientLastName,
                sectionId: state.fields?.sectionId[0].id,
                docterId: state.fields?.docterId?.[0]?.id,
                patientBiography: state.fields?.patientBiography
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();

                ref.insert.current.loading(false);
                this.close(true);
            }).catch(message => {
                ref.insert.current.loading(false);
                this.setState({error: message});
            });
        }
    }

    open(data, action) {
        console.log(data,'farshad');
        const {props} = this;
        const fields = {};
        if (action === 'SECTION_INSERT' || action === 'BLOOD_BANK_INSERT') {
            fields.sectionId = [{id: props.user.sectionId}];
            if (action === 'SECTION_INSERT')
                fields.sectionRequestDateTime = moment();

            this.setState({
                data,
                action,
                fields,
                error: null
            });
        } else if (action === 'SECTION_UPDATE' || action === 'BLOOD_BANK_UPDATE' || action === ModalAction.VIEW) {
            this.setState({
                data,
                action,
                feilds: {},
                error: null,
                loading: 'در حال دریافت اطلاعات درخواست'
            });

            if (data?.sectionRequestId)
                SectionOrgEmerRequest.data({sectionRequestId: data?.sectionRequestId})
                    .then(data => {
                        this.setState({
                            patientFileInfo: {
                                patientProvinceStr: data.patientProvinceStr,
                                patientCityStr: data.patientCityStr,
                                patientFirstName: data.patientFirstName,
                                patientFileCode: data.patientFileCode,
                                patientFileCodeId: data.patientFileCodeId
                            },
                            fields: {
                                patientProvinceStr: data.patientProvinceStr,
                                patientCityStr: data.patientCityStr,
                                patientFullName: `${data.patientFirstName} ${data.patientLastName}`,
                                patientFileCode: data.patientFileCode,
                                sectionRequestDateTime: data.createDateTime ? moment(data.createDateTime) : null,
                                patientFileCodeId: data?.patientFileCodeId,
                                sectionId: [{id: data?.sectionId}],
                                docterId: [{id:data?.docterId}],
                                patientBiography: data?.patientBiography,
                                wbJson: data?.wb ? {
                                    o_POSCount: data?.wb?.o_POSCount,
                                    o_NEGCount: data?.wb?.o_NEGCount,
                                    a_POSCount: data?.wb?.a_POSCount,
                                    a_NEGCount: data?.wb?.a_NEGCount,
                                    b_POSCount: data?.wb?.b_POSCount,
                                    b_NEGCount: data?.wb?.b_NEGCount,
                                    aB_POSCount: data?.wb?.aB_POSCount,
                                    aB_NEGCount: data?.wb?.aB_NEGCount,
                                    description: data?.wb?.description
                                } : {},
                                rbcJson: data?.wb ? {
                                    o_POSCount: data?.rbc?.o_POSCount,
                                    o_NEGCount: data?.rbc?.o_NEGCount,
                                    a_POSCount: data?.rbc?.a_POSCount,
                                    a_NEGCount: data?.rbc?.a_NEGCount,
                                    b_POSCount: data?.rbc?.b_POSCount,
                                    b_NEGCount: data?.rbc?.b_NEGCount,
                                    aB_POSCount: data?.rbc?.aB_POSCount,
                                    aB_NEGCount: data?.rbc?.aB_NEGCount,
                                    description: data?.rbc?.description
                                } : {},
                                pltJson: data?.wb ? {
                                    o_POSCount: data?.plt?.o_POSCount,
                                    o_NEGCount: data?.plt?.o_NEGCount,
                                    a_POSCount: data?.plt?.a_POSCount,
                                    a_NEGCount: data?.plt?.a_NEGCount,
                                    b_POSCount: data?.plt?.b_POSCount,
                                    b_NEGCount: data?.plt?.b_NEGCount,
                                    aB_POSCount: data?.plt?.aB_POSCount,
                                    aB_NEGCount: data?.plt?.aB_NEGCount,
                                    description: data?.plt?.description
                                } : {},
                                ffpJson: data?.wb ? {
                                    o_POSCount: data?.ffp?.o_POSCount,
                                    o_NEGCount: data?.ffp?.o_NEGCount,
                                    a_POSCount: data?.ffp?.a_POSCount,
                                    a_NEGCount: data?.ffp?.a_NEGCount,
                                    b_POSCount: data?.ffp?.b_POSCount,
                                    b_NEGCount: data?.ffp?.b_NEGCount,
                                    aB_POSCount: data?.ffp?.aB_POSCount,
                                    aB_NEGCount: data?.ffp?.aB_NEGCount,
                                    description: data?.ffp?.description
                                } : {},
                                cryJson: data?.wb ? {
                                    o_POSCount: data?.cry?.o_POSCount,
                                    o_NEGCount: data?.cry?.o_NEGCount,
                                    a_POSCount: data?.cry?.a_POSCount,
                                    a_NEGCount: data?.cry?.a_NEGCount,
                                    b_POSCount: data?.cry?.b_POSCount,
                                    b_NEGCount: data?.cry?.b_NEGCount,
                                    aB_POSCount: data?.cry?.aB_POSCount,
                                    aB_NEGCount: data?.cry?.aB_NEGCount,
                                    description: data?.cry?.description
                                } : {},
                                bloodBankRequestDateTime: data?.bloodBankRequestDateTime ? moment(data?.bloodBankRequestDateTime) : moment(),
                                bloodBankName: data?.bloodBankName || props.user.userFullName
                            },
                            loading: null
                        });
                    })
                    .catch(message => {
                        new Notif({message, thene: 'error'}).show();

                        this.close();
                    });

            if (data?.hospitalRequestId)
                OrganizationOrgEmerRequest.data({hospitalRequestId: data?.hospitalRequestId})
                    .then(data => {
                        this.setState({
                            patientFileInfo: {
                                patientProvinceStr: data.patientProvinceStr,
                                patientCityStr: data.patientCityStr,
                                patientFirstName: data.patientFirstName,
                                patientFileCode: data.patientFileCode,
                                patientFileCodeId: data.patientFileCodeId
                            },
                            fields: {
                                patientProvinceStr: data.patientProvinceStr,
                                patientCityStr: data.patientCityStr,
                                patientFullName: data.patientFirstName ? `${data.patientFirstName} ${data.patientLastName}` : '',
                                patientFileCode: data.patientFileCode,
                                sectionRequestDateTime: data.createDateTime ? moment(data.createDateTime) : null,
                                patientFileCodeId: data?.patientFileCodeId,
                                sectionId: [{id: data?.sectionId}],
                                docterId: [{id:data?.docterId}],
                                patientBiography: data?.patientBiography,
                                wbJson: data?.wb ? {
                                    o_POSCount: data?.wb?.o_POSCount,
                                    o_NEGCount: data?.wb?.o_NEGCount,
                                    a_POSCount: data?.wb?.a_POSCount,
                                    a_NEGCount: data?.wb?.a_NEGCount,
                                    b_POSCount: data?.wb?.b_POSCount,
                                    b_NEGCount: data?.wb?.b_NEGCount,
                                    aB_POSCount: data?.wb?.aB_POSCount,
                                    aB_NEGCount: data?.wb?.aB_NEGCount,
                                    description: data?.wb?.description
                                } : {},
                                rbcJson: data?.wb ? {
                                    o_POSCount: data?.rbc?.o_POSCount,
                                    o_NEGCount: data?.rbc?.o_NEGCount,
                                    a_POSCount: data?.rbc?.a_POSCount,
                                    a_NEGCount: data?.rbc?.a_NEGCount,
                                    b_POSCount: data?.rbc?.b_POSCount,
                                    b_NEGCount: data?.rbc?.b_NEGCount,
                                    aB_POSCount: data?.rbc?.aB_POSCount,
                                    aB_NEGCount: data?.rbc?.aB_NEGCount,
                                    description: data?.rbc?.description
                                } : {},
                                pltJson: data?.wb ? {
                                    o_POSCount: data?.plt?.o_POSCount,
                                    o_NEGCount: data?.plt?.o_NEGCount,
                                    a_POSCount: data?.plt?.a_POSCount,
                                    a_NEGCount: data?.plt?.a_NEGCount,
                                    b_POSCount: data?.plt?.b_POSCount,
                                    b_NEGCount: data?.plt?.b_NEGCount,
                                    aB_POSCount: data?.plt?.aB_POSCount,
                                    aB_NEGCount: data?.plt?.aB_NEGCount,
                                    description: data?.plt?.description
                                } : {},
                                ffpJson: data?.wb ? {
                                    o_POSCount: data?.ffp?.o_POSCount,
                                    o_NEGCount: data?.ffp?.o_NEGCount,
                                    a_POSCount: data?.ffp?.a_POSCount,
                                    a_NEGCount: data?.ffp?.a_NEGCount,
                                    b_POSCount: data?.ffp?.b_POSCount,
                                    b_NEGCount: data?.ffp?.b_NEGCount,
                                    aB_POSCount: data?.ffp?.aB_POSCount,
                                    aB_NEGCount: data?.ffp?.aB_NEGCount,
                                    description: data?.ffp?.description
                                } : {},
                                cryJson: data?.wb ? {
                                    o_POSCount: data?.cry?.o_POSCount,
                                    o_NEGCount: data?.cry?.o_NEGCount,
                                    a_POSCount: data?.cry?.a_POSCount,
                                    a_NEGCount: data?.cry?.a_NEGCount,
                                    b_POSCount: data?.cry?.b_POSCount,
                                    b_NEGCount: data?.cry?.b_NEGCount,
                                    aB_POSCount: data?.cry?.aB_POSCount,
                                    aB_NEGCount: data?.cry?.aB_NEGCount,
                                    description: data?.cry?.description
                                } : {},
                                bloodBankRequestDateTime: data?.bloodBankRequestDateTime ? moment(data?.bloodBankRequestDateTime) : moment(),
                                bloodBankName: data?.bloodBankName || props.user.userFullName
                            },
                            loading: null
                        });
                    })
                    .catch(message => {
                        new Notif({message, thene: 'error'}).show();

                        this.close();
                    });
        }

        this.ref.modal.current.open()
            .then(_ => {
                if (this.ref.patientFileCode.current)
                    this.ref.patientFileCode.current.focus();
            });
    }

    patientFileCodeSubmitHandler(value) {
        if (!value)
            this.setState({patientFileInfo: undefined});

        if (value) {
            this.setState({
                patientFileInfo: undefined,
                loading: 'در حال دریافت پرونده بیمار'
            });

            Patient.data({
                patientFileCode: value
            })
                .then(data => {
                    this.setState({
                        patientFileInfo: data,
                        fields: {
                            ...this.state.fields,
                            patientProvinceStr: data.patientProvinceStr,
                            patientCityStr: data.patientCityStr,
                            patientFullName: `${data.patientFirstName} ${data.patientLastName}`,
                            patientFileCode: data.patientFileCode,
                            sectionRequestDateTime: moment()
                        },
                        loading: false
                    });
                })
                .catch(message => {
                    this.setState({
                        patientFileInfo: undefined,
                        isNewPatient: true,
                        loading: false
                    });

                    new Notif({message, theme: 'error'}).show();
                });
        }
    }

    updateBloodBankClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            ref.bloodBankUpdate.current.loading();
            this.setState({error: null});

            HospitalOrgEmerRequest.update({
                hospitalEmgRequestId: state.data?.hospitalEmgRequestId,
                wbJson: {
                    o_POSCount: state.fields?.wbJson?.o_POSCount || 0,
                    o_NEGCount: state.fields?.wbJson?.o_NEGCount || 0,
                    a_POSCount: state.fields?.wbJson?.a_POSCount || 0,
                    a_NEGCount: state.fields?.wbJson?.a_NEGCount || 0,
                    b_POSCount: state.fields?.wbJson?.b_POSCount || 0,
                    b_NEGCount: state.fields?.wbJson?.b_NEGCount || 0,
                    aB_POSCount: state.fields?.wbJson?.aB_POSCount || 0,
                    aB_NEGCount: state.fields?.wbJson?.aB_NEGCount || 0,
                    sum: state.fields?.wbJson?.sum || 0,
                    description: state.fields?.wbJson?.description
                },
                rbcJson: {
                    o_POSCount: state.fields?.rbcJson?.o_POSCount || 0,
                    o_NEGCount: state.fields?.rbcJson?.o_NEGCount || 0,
                    a_POSCount: state.fields?.rbcJson?.a_POSCount || 0,
                    a_NEGCount: state.fields?.rbcJson?.a_NEGCount || 0,
                    b_POSCount: state.fields?.rbcJson?.b_POSCount || 0,
                    b_NEGCount: state.fields?.rbcJson?.b_NEGCount || 0,
                    aB_POSCount: state.fields?.rbcJson?.aB_POSCount || 0,
                    aB_NEGCount: state.fields?.rbcJson?.aB_NEGCount || 0,
                    sum: state.fields?.rbcJson?.sum || 0,
                    description: state.fields?.rbcJson?.description
                },
                pltJson: {
                    o_POSCount: state.fields?.pltJson?.o_POSCount || 0,
                    o_NEGCount: state.fields?.pltJson?.o_NEGCount || 0,
                    a_POSCount: state.fields?.pltJson?.a_POSCount || 0,
                    a_NEGCount: state.fields?.pltJson?.a_NEGCount || 0,
                    b_POSCount: state.fields?.pltJson?.b_POSCount || 0,
                    b_NEGCount: state.fields?.pltJson?.b_NEGCount || 0,
                    aB_POSCount: state.fields?.pltJson?.aB_POSCount || 0,
                    aB_NEGCount: state.fields?.pltJson?.aB_NEGCount || 0,
                    sum: state.fields?.pltJson?.sum || 0,
                    description: state.fields?.pltJson?.description,
                },
                ffpJson: {
                    o_POSCount: state.fields?.ffpJson?.o_POSCount || 0,
                    o_NEGCount: state.fields?.ffpJson?.o_NEGCount || 0,
                    a_POSCount: state.fields?.ffpJson?.a_POSCount || 0,
                    a_NEGCount: state.fields?.ffpJson?.a_NEGCount || 0,
                    b_POSCount: state.fields?.ffpJson?.b_POSCount || 0,
                    b_NEGCount: state.fields?.ffpJson?.b_NEGCount || 0,
                    aB_POSCount: state.fields?.ffpJson?.aB_POSCount || 0,
                    aB_NEGCount: state.fields?.ffpJson?.aB_NEGCount || 0,
                    sum: state.fields?.ffpJson?.sum || 0,
                    description: state.fields?.ffpJson?.description,
                },
                cryJson: {
                    o_POSCount: state.fields?.cryJson?.o_POSCount || 0,
                    o_NEGCount: state.fields?.cryJson?.o_NEGCount || 0,
                    a_POSCount: state.fields?.cryJson?.a_POSCount || 0,
                    a_NEGCount: state.fields?.cryJson?.a_NEGCount || 0,
                    b_POSCount: state.fields?.cryJson?.b_POSCount || 0,
                    b_NEGCount: state.fields?.cryJson?.b_NEGCount || 0,
                    aB_POSCount: state.fields?.cryJson?.aB_POSCount || 0,
                    aB_NEGCount: state.fields?.cryJson?.aB_NEGCount || 0,
                    sum: state.fields?.cryJson?.sum || 0,
                    description: state.fields?.cryJson?.description,
                }
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.UPDATE_SUCCESSFUL).show();

                ref.bloodBankUpdate.current.loading(false);

                this.close(true);
            }).catch(message => {
                ref.bloodBankUpdate.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    updateSectionClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            if (!state.patientFileInfo) {
                new Notif({message: 'شماره پرونده بیمار معتبر نمی باشد.', theme: 'error'}).show();
                return;
            }

            ref.sectionUpdate.current.loading();
            this.setState({error: null});

            SectionOrgEmerRequest.update({
                hospitalEmgRequestId: state.data?.hospitalEmgRequestId,
                patientFileCodeId: state.patientFileInfo?.patientFileCodeId,
                patientFileCode: state.patientFileInfo?.patientFileCode,
                patientFirstName: state.patientFileInfo?.patientFirstName,
                patientLastName: state.patientFileInfo?.patientLastName,
                sectionId: state.fields?.sectionId[0].id,
                docterId: state.fields?.docterId?.[0]?.id,
                patientBiography: state.fields?.patientBiography
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.UPDATE_SUCCESSFUL).show();

                ref.sectionUpdate.current.loading(false);
                this.close(true);
            }).catch(message => {
                ref.sectionUpdate.current.loading(false);
                this.setState({error: message});
            });
        }
    }

    validate() {
        const {ref} = this;

        const validate = Tool.validate(ref.sectionId,
            ref.patientFileCode,
            ref.docterId,
            ref.patientBiography,
            ref.sectionId);

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        base: state.base
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateBase: props => dispatch(updateBase(props))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalOrgEmerRequest);